import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import {CommonMessages,ClientMessages} from 'src/app/shared/messages/messages.enum';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-journeytype',
  templateUrl: './journeytype.component.html',
  styleUrls: ['./journeytype.component.css']
})
export class JourneytypeComponent extends BaseComponent implements OnInit {

  public journeytypeObj: any = [];
  cp = 1;
  ord = true;
  colname: "Journey type Name";
  text;
  checked = false;

  today: number = Date.now();
  constructor(private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService
  ) { 
    super();
  }
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getJourneytype();
  }
  getJourneytype() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getJourneytype().subscribe(data => {
      self.journeytypeObj = data;
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  editJourneytype(id) {
    this.router.navigate(['/corporate/newjourneytype'], { queryParams: { journey_type_id: id } });
  }
  deleteJourneytype(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delJourneytype(obj).subscribe(data => {
            if (data.status) {
              this.getJourneytype();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
          //  console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateJourneytypeStatus(event, id) {
    let value = event.source.checked;
    let obj = this.journeytypeObj.find(element => {
      if (element.journey_type_id === id) {
        return true;
      }
    });
    obj = obj;
    obj.isactive = value;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', CommonMessages.activeInactiveConfirmation +" '"+ (value? "Active": "Inactive") +"'", 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          let journeytypeObj = {            
            isactive: obj.isactive,
            journey_type_id: id
          }
          this.ngxSpinnerService.show();
          this.master.updateJourneytypeStatus(journeytypeObj).subscribe(data => {
            if (data.status) {
              this.toastrService.success(CommonMessages.statusUpdated);
              this.ngxSpinnerService.hide();
            }
          }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => {
        event.source.checked = !event.source.checked;
       // console.log(CommonMessages.dialogDismissMessage)
      });
  }
  clickEvent() { }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-theme-import.csv`, 'addingThemeBulk')
      .then(data => {
       // console.log(data);
        this.ngxSpinnerService.show();
        self.getJourneytype();
      })
      .catch(err => {
        console.error(err);
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_journey_type_tbl"
    }
    this.ngxSpinnerService.show();
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
      this.ngxSpinnerService.hide();
    }, err => {
      this.toastrService.error(err.message);
      this.ngxSpinnerService.hide();
    });
  }
}